/*
 * types/services/dr2am.tasks.orders.proto
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: version not set
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.21
 *
 * Do not edit the class manually.
 *
 */

import {ApiClient} from '../ApiClient';
import {PbOrder} from './PbOrder';
import {PbResponseState} from './PbResponseState';

/**
 * The ServiceGetOrdersWithUserResponse model module.
 * @module model/ServiceGetOrdersWithUserResponse
 * @version version not set
 */
export class ServiceGetOrdersWithUserResponse {
  /**
   * Constructs a new <code>ServiceGetOrdersWithUserResponse</code>.
   * @alias module:model/ServiceGetOrdersWithUserResponse
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>ServiceGetOrdersWithUserResponse</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ServiceGetOrdersWithUserResponse} obj Optional instance to populate.
   * @return {module:model/ServiceGetOrdersWithUserResponse} The populated <code>ServiceGetOrdersWithUserResponse</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new ServiceGetOrdersWithUserResponse();
      if (data.hasOwnProperty('order'))
        obj.order = ApiClient.convertToType(data['order'], [PbOrder]);
      if (data.hasOwnProperty('state'))
        obj.state = PbResponseState.constructFromObject(data['state']);
    }
    return obj;
  }
}

/**
 * @member {Array.<module:model/PbOrder>} order
 */
ServiceGetOrdersWithUserResponse.prototype.order = undefined;

/**
 * @member {module:model/PbResponseState} state
 */
ServiceGetOrdersWithUserResponse.prototype.state = undefined;


